<script>
import BaseButton from '@/js/components/common/buttons/BaseButton';

export default {
    name: 'CancelButton',

    functional: true,

    props: {
        label: {type: String, default: null},
        hideLabel: {type: Boolean},
        isSmall: {type: Boolean},
        disabled: {type: Boolean},
        asLink: {type: Boolean},
    },

    render(createElement, {props, data, parent}) {
        data.props = {
            label: props.label || parent.$t('common.actions.cancel'),
            iconClass: props.asLink ? null : 'fa fa-times',
            color: props.asLink ? 'btn-link' : 'btn-secondary',
            isSmall: props.isSmall,
            hideLabel: props.hideLabel,
            disabled: props.disabled,
        };

        data.attrs = {
            ...data.attrs,
            tabindex: -1,
        };

        return createElement(BaseButton, data);
    },
};
</script>
